import {
  Component,
  Input,
  SimpleChanges,
  OnChanges,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { formatCurrency } from "@angular/common"
import {
  CustomerLoanStatus,
  DateHelper,
  NeedsAttentionHelper,
  NeedsAttentionModel
} from "common";
import { LoanData, ProductCode } from "../../loan/domain/models/loan.model";
import { MatDialog } from "@angular/material/dialog";
import { AccountStatusIconChipModel } from "../account-status-icon-chip/account-status-icon-chip.model";

@Component({
    selector: "ifp-loc-law-card-chart",
    templateUrl: "./loc-law-card-chart.component.html",
    styleUrls: ["./loc-law-card-chart.component.scss"],
    standalone: false
})
export class LocLawChartContentComponent implements OnInit, OnChanges {
  @Input() loan: LoanData;
  @Input() showAvailableFunds: boolean;
  @Input() widgetLayout: boolean;
  @Input() hasAvailableRenewalToSign: boolean;
  @Input() needsAttentionModel: NeedsAttentionModel;

  fundsAvailableFaktor: number;
  fundsAvailable: string;
  drawEnabled: boolean;
  payEnabled: boolean;
  loanStatus = CustomerLoanStatus;
  pendingCustomer: boolean;
  utilization: number;
  productCodes = ProductCode;
  resolveCaseEnabled: boolean;
  casePaymentRequired: boolean;
  casePaymentWithinDays: number;
  accountStatusIconChipModel: AccountStatusIconChipModel;

  get isLocLoan() {
    return this.loan?.productCode === this.productCodes.LOC;
  }

  constructor(protected router: Router, protected dialog: MatDialog) { }

  ngOnInit() {
    this.bindData();
  }

  ngOnChanges(_: SimpleChanges): void {
    this.bindData();
  }

  bindData() {
    if (this.loan && this.loan.loanInfo) {
      this.fundsAvailableFaktor =
        this.loan.loanInfo.availableFunds / this.loan.loanInfo.creditLimit;
      this.fundsAvailable = formatCurrency(
        this.loan.loanInfo.availableFunds,
        "en_US",
        "$",
        undefined,
        "1.0-0"
      );
      this.drawEnabled = this.loan?.isDrawVisible;
      this.payEnabled = this.loan?.isPayVisible;
    }

    if(this.loan && this.loan.productCode === ProductCode.Law && this.loan.fullRepaymentDueDate) {
      this.casePaymentRequired = true;
      const fullRepaymentDueDate = DateHelper.setToStartOfDay(new Date(this.loan.fullRepaymentDueDate));
      const today = DateHelper.setToStartOfDay(new Date());
      this.casePaymentWithinDays = Math.floor((fullRepaymentDueDate.getTime() - today.getTime()) / (1000 * 3600 * 24));
    }

    this.utilization = this.getUtilization();

    this.accountStatusIconChipModel = { 
      needsAttentionMessage: NeedsAttentionHelper.getNeedsAttentionMessageWithProductCode(this.needsAttentionModel.messageInput, this.loan.productCode),
    };
  }

  onClickDraw() {
    if(this.needsAttentionModel?.isApplicable) {
      NeedsAttentionHelper.openNeedsAttentionDialog(this.dialog, this.needsAttentionModel.messageInput, this.loan.productCode);
      return;
    }

    this.router.navigate([`account/${this.loan.id}/transfer/draw`]);
  }

  onClickPayment() {
    this.router.navigate([`account/${this.loan.id}/transfer/payment`]);
  }

  getUtilization(): number {
    return Math.round(
      (this.loan.loanInfo.availableFunds / this.loan.loanInfo.creditLimit) * 100
    );
  }

}
